export function mapsEqualIfEmpty(a, b) {
    return a === b || (a.size === 0 && b.size === 0);
}
